import icons from "../../constants/icons";
import "./styles.css";

const CollapseCardItem = (props) => {
  return (
    <div key={props.id}>
      <div
        className={`collapse-card-item-container ${
          props.isCollapsed && "active"
        } ${props.isCollapsed && "no-border-top"}`}
        onClick={props.handleCollapse}
      >
        <div style={{ display: "flex", flex: 1 }}>
          <div className="collapse-card-item-icon">
            <span className={process.env.REACT_APP_ICONS_TYPE}>
              {props.icon}
            </span>
          </div>
          <div className="collapse-text-container">
            <h3 className="text-bold">{props.title}</h3>
            {props.subTitle && <p className="text-bold">{props.subTitle}</p>}
            <p style={{ marginTop: "0.3rem" }}>{props.description}</p>
          </div>
        </div>
        <div className={`icon-container }`}>
          <span className={process.env.REACT_APP_ICONS_TYPE}>
            {/* props.provided
              ? icons.success
              ${props.provided ? "active" : ""
              :  */}
            {props.isCollapsed ? icons.chevronUp : icons.chevronDown}
          </span>
        </div>
      </div>
      {props.isCollapsed && props.data}
    </div>
  );
};

export default CollapseCardItem;
